import styled from 'styled-components';
import Button from '../../Button';

export const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 450px;
	overflow-x: hidden;
	height: 100%;

	&.apartPage {
		max-height: 360px;
		gap: 24px;
		position: relative;
		@media (max-width: 600px) {
			max-height: 450px;
		}
	}

	&.apartSelectionList {
		position: relative;
		row-gap: 16px;

		@media (max-width: 800px) {
			max-width: none;
		}
	}

	&.likeCard {
		padding: 24px;
		row-gap: 16px;
	}
`;

export const HeadLineWrapper = styled.div`
	display: flex;
	gap: 12px;
`;

export const Title = styled.div`
	${({ theme }) => theme && theme.typography.textBoldL};

	&.apartPage {
		${({ theme }) => theme && theme.typography.textBoldL};
	}

	&.apartSelectionList {
		${({ theme }) => theme && theme.typography.textBoldL};
		margin-bottom: 0;
	}

	@media (max-width: 600px) {
		margin-bottom: 8px;
		font-size: 20px;
	}
`;

export const DislikesWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	max-height: calc(100vh - 330px);
	overflow-y: auto;
	gap: 24px;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: stretch;

	@media (max-width: 600px) {
		margin: 8px 0 0;
	}
`;

export const ButtonsGroup = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ButtonsGroupTitle = styled.div`
	text-align: left;
	${({ theme }) => theme && theme.typography.textBoldM};
`;

export const DislikeButtons = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const StyledButton = styled(Button)`
	border-radius: 0;
	width: calc(100% + 32px);
	height: 64px;
	${({ theme }) => theme && theme.typography.buttonM};

	&:hover {
		background-color: ${({ theme }) => theme && theme.primaryHover};
		border-color: ${({ theme }) => theme && theme.primaryHover};
	}
	&:active {
		background-color: ${({ theme }) => theme && theme.primaryHover};
		border-color: ${({ theme }) => theme && theme.primaryHover};
	}
`;

export const SelectBtnWrapper = styled.button`
	display: flex;
	align-items: center;
	padding: 5px 11px;
	background-color: ${({ theme, isActive }) => (isActive ? theme.newDarkGrayColor : theme.lightGrayColor)};
	margin: 12px 12px 0 0;
	height: 32px;
	border-radius: 4px;
	cursor: pointer;
	border: none;
	box-shadow: none;

	&:active {
		background-color: ${({ theme }) => theme && theme.darkGrayColor};
	}

	&:hover {
		background-color: ${({ theme }) => theme && theme.middleGrayColor};
	}
`;

export const SelectBtn = styled.span`
	${({ theme }) => theme && theme.typography.textMediumS};
	color: ${({ theme, isActive }) => (isActive ? '#fff' : theme.primaryBlackColor)};
`;

export const DislikeSvg = styled.svg`
	width: 22px;
	height: 22px;
	margin-right: 6px;
	display: ${({ isShow }) => !isShow && `none`};
	fill: #fff;
`;

export const BtnClose = styled.button`
	outline: none;
	min-width: 40px;
	height: 40px;
	background-color: #fff;
	cursor: pointer;
	border: none;
	padding: 0;
	font-size: 32px;
	z-index: 1202;
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;
export const Text = styled.div`
	${({ theme }) => theme && theme.typography.textS};
`;

export const PopupImg = styled.div`
	img {
		width: 54px;
		height: 54px;
	}
`;
